var scope_0 = require('/codebuild/output/src3605572746/src/personal-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2a54b7428ef61b0788b623afaffd648b.js').default;
var scope_1 = require('/codebuild/output/src3605572746/src/personal-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    